import { EXT_MODULES } from "./cr.ext";
import { useCrusade } from "./crusade";
import { usePlayer } from "./player";

export function useExt() {
    const player = usePlayer()
    const ext = player.crusade.ext;
    const vanilla = EXT_MODULES['VANILLA']
    const module = EXT_MODULES[ext]

    return {
        ...vanilla,
        ...module,
    }
}